/* eslint-disable camelcase */
import * as React from 'react';
import { useLocation, useNavigate } from 'react-router';
import { parse } from 'query-string';
import { toast } from 'react-toastify';
import { jobAdder } from '../../../core/constants';
import { exchangeAuthCode, updateIntegrationToCustomer } from '../../../core/integrations';
import { generateJobAdderAccessTokenFromAuthCode } from '../../../core/thirdPartyIntegrations';
import { useAsyncAction } from '../../../commonComponents/Hooks';
import Loading from '../../../commonComponents/Loading';

const ThirdPartyIntegrationAuthorization = ({ integrationName }: props) => {
	const [, , performAsyncAction] = useAsyncAction();
	const location = useLocation();
	const navigate = useNavigate();
	const queryParams = parse(location.search);
	const authCode = queryParams.code as string;
	const customerIntegrationId =
		integrationName === jobAdder ? (queryParams.state as string) : (queryParams.customerIntegrationId as string);

	React.useEffect(() => {
		performAsyncAction(async () => {
			const ids = customerIntegrationId.split('-');
			const customerId = Number(ids[0]);
			const integrationId = Number(ids[1]);
			const integrationUserId = Number(ids[2]);
			const redirectUri = `${window.location.origin}/integration/${integrationName}/auth${
				integrationName === jobAdder ? '' : `?customerIntegrationId=${customerIntegrationId}`
			}`;

			let accessToken: string;

			if (integrationName === jobAdder) {
				const tokens = await generateJobAdderAccessTokenFromAuthCode(authCode, redirectUri);
				accessToken = tokens?.accessToken;
				const refreshToken = tokens?.refreshToken;
				await updateIntegrationToCustomer(customerId, integrationId, accessToken, refreshToken, integrationUserId, '');
			} else {
				// Bullhorn: backend handles code exchange and stores tokens
				const tokens = await exchangeAuthCode(customerId, integrationId, authCode, redirectUri, integrationUserId);
				accessToken = tokens.accessToken;
			}

			if (accessToken) {
				toast('Authorized successfully');
				navigate(integrationUserId > 0 ? `/account` : `/customers/${customerId}/integrations`);
			}
		});
	}, []);

	return <Loading />;
};

export default ThirdPartyIntegrationAuthorization;

interface props {
	integrationName: string;
}
